export default __webpack_public_path__ + "static/media/boitier.0e3791d9.svg";